import React from 'react'
import { TableWrapper } from '../UI/styledConstants';
import bbpsLogo2 from '../../assets/images/BBPS3.svg';
import bgImg from '../../assets/images/bg-img.png';

function BillDetails({billDetails,onClick=()=>{}}) {
  return (
   
		<>
		<TableWrapper img={bgImg} className='p-10'>
			<div className="flex justify-between align-center BilDaitalHeader">
				<h2>Bill Details</h2>
				<img src={bbpsLogo2} alt="bbps logo" style={{ width:"60px"}} />
			</div>
			<div className="flex justify-between BilDaitalRow">
				<div className="heading">Customer Name</div>
				<div className="value">{billDetails?.billerResponse?.customerName}</div>
			</div>
			<div className="flex justify-between BilDaitalRow">
				<div className="heading">Bill Number</div>
				<div className="value">{billDetails?.billerResponse?.billNumber}</div>
			</div>
			{billDetails?.billDetails &&
				billDetails?.billDetails.map((val, index) => {
					return (
						<div className="flex justify-between BilDaitalRow" key={index}>
							<div className="heading">{val.name}</div>
							<div className="value">{val.value}</div>
						</div>
					);
				})}
			<div className="flex justify-between BilDaitalRow">
				<div className="heading">Bill Date</div>
				<div className="value">{billDetails?.billerResponse?.billDate}</div>
			</div>
			<div className="flex justify-between BilDaitalRow">
				<div className="heading">Bill Period</div>
				<div className="value">{billDetails?.billerResponse?.billPeriod}</div>
			</div>
			<div className="flex justify-between BilDaitalRow">
				<div className="heading">Due Date</div>
				<div className="value">{billDetails?.billerResponse?.dueDate}</div>
			</div>
			<div className="flex justify-between BilDaitalRow">
				<div className="heading">Amount</div>
				<div className="value">&#8377; {billDetails?.billerResponse?.amount}</div>
			</div>
		</TableWrapper>
		{/* <button className="button-outline mt20" onClick={() => onClick(billDetails?.billerResponse?.amount)} style={{ maxWidth: '142px' }}>
			Pay
		</button> */}
	</>
	)
  
}

export default BillDetails;